// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"215":"4bb56fef","294":"7568b4d6","487":"1f81bc33","591":"5a77140b"}[chunkId] + ".chunk.js";
};